import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, FileText, Award } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const statsContent = {
  stats: [{
    icon: 'Users',
    value: '+850',
    label: 'Profesionales lo usan'
  }, {
    icon: 'BookOpen',
    value: '6',
    label: 'Tomos clínicos'
  }, {
    icon: 'FileText',
    value: '+100',
    label: 'Recursos editables'
  }, {
    icon: 'Award',
    value: '4.9/5',
    label: 'Calificación promedio'
  }]
};
const iconMap: Record<string, React.ElementType> = {
  Users,
  BookOpen,
  FileText,
  Award
};
export function Stats() {
  return <section className="py-16 px-4 bg-[#0f0f0f] border-y border-brand-cardBorder" data-id="element-216">
      <div className="max-w-6xl mx-auto" data-id="element-217">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-218">
          {statsContent.stats.map((stat, index) => {
          const IconComponent = iconMap[stat.icon] || Users;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="text-center flex flex-col items-center" data-id="element-219">
                <IconComponent className="w-7 h-7 text-brand-accent mb-3" data-id="element-220" />
                <span className="text-3xl md:text-4xl font-serif font-bold text-brand-light mb-1" data-id="element-221">
                  {stat.value}
                </span>
                <span className="text-sm text-brand-light/60 font-sans" data-id="element-222">
                  {stat.label}
                </span>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}